import { createFileRoute } from "@tanstack/react-router";
import {
  publicImagesQueryOptions,
  userProfileQueryOptions,
} from "~/features/profile/api";
import { UserProfileSkeleton } from "~/features/profile/components/UserProfileSkeleton";
import { UserProfileTemplate } from "~/features/profile/UserProfileTemplate";

const ProfileUserPage = () => {
  const { userId } = Route.useParams();
  return <UserProfileTemplate userId={userId} />;
};

export const Route = createFileRoute("/_authenticated/profile/$userId")({
  loader: ({ context: { queryClient }, params: { userId } }) =>
    Promise.all([
      queryClient.ensureQueryData(userProfileQueryOptions(userId)),
      queryClient.ensureQueryData(publicImagesQueryOptions(userId)),
    ]),
  pendingMs: 200,
  pendingMinMs: 300,
  pendingComponent: UserProfileSkeleton,
  component: ProfileUserPage,
});
